import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountVendorPayments,
  getAccountVendorPayment,
  createAccountVendorPayment,
  deleteAccountVendorPayment,
} from "api/accountVendorPaymentApi"

export const ACCOUNT_VENDOR_PAYMENT_QUERY_KEY = "account-vendor-payments"

export const useAccountVendorPayments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_VENDOR_PAYMENT_QUERY_KEY,
    getAccountVendorPayments,
    params,
    enabled
  )
}

export const useAccountVendorPayment = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_VENDOR_PAYMENT_QUERY_KEY,
    getAccountVendorPayment,
    id,
    enabled
  )
}

export const useCreateAccountVendorPayment = () => {
  return useCreateResource(
    createAccountVendorPayment,
    ACCOUNT_VENDOR_PAYMENT_QUERY_KEY
  )
}

export const useDeleteAccountVendorPayment = () => {
  return useDeleteResource(
    deleteAccountVendorPayment,
    ACCOUNT_VENDOR_PAYMENT_QUERY_KEY
  )
}
